import { render, staticRenderFns } from "./PaymentConfirm.vue?vue&type=template&id=449d7282"
import script from "./PaymentConfirm.vue?vue&type=script&lang=ts"
export * from "./PaymentConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports